import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";
import { FiTrash2, FiPlus, FiArrowLeft, FiDollarSign, FiCreditCard, FiHash, FiCalendar } from "react-icons/fi";

export default function NewButcherPayment() {
  const [butchers, setButchers] = useState([]);
  const [selectedButcherId, setSelectedButcherId] = useState("");
  const [animalTypes, setAnimalTypes] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  // --- Payment States ---
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [penalty, setPenalty] = useState(0);

  // --- Conditional Detail States ---
  const [chequeNo, setChequeNo] = useState("");
  const [bankName, setBankName] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [transferDate, setTransferDate] = useState("");

  const [rowInput, setRowInput] = useState({
    qurbani_day: "1",
    category: "",
    sub_category: "",
    no_of_animal: "",
    rate: "",
  });

  const [paymentList, setPaymentList] = useState([]);
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('token');
      const headers = { 'Authorization': `Bearer ${token}` };
      try {
        const resButchers = await fetch(`${config.baseUrl}/api/butcher/butchers`, { headers });
        const dataButchers = await resButchers.json();
        setButchers(Array.isArray(dataButchers) ? dataButchers : []);

        const resTypes = await fetch(`${config.baseUrl}/api/subcategories/filteranimal-type`, { headers });
        const dataTypes = await resTypes.json();
        setAnimalTypes(Array.isArray(dataTypes) ? dataTypes : []);
      } catch (error) {
        console.error("Initialization error:", error);
      }
    };
    fetchData();
  }, []);

  const fetchSubCategories = async (catId) => {
    const selectedYear = localStorage.getItem('qurbani_year') || new Date().getFullYear();
    if (!catId) {
      setSubCategories([]);
      return;
    }
    try {
      const res = await fetch(`${config.baseUrl}/api/subcategories/filtersubcat/${catId}?year=${selectedYear}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const data = await res.json();
      setSubCategories(data);
    } catch (err) { console.error("Error fetching subcategories:", err); }
  };

  const handleCategoryChange = (e) => {
    const catId = e.target.value;
    setRowInput({ ...rowInput, category: catId, sub_category: "" });
    fetchSubCategories(catId);
  };

  const handleButcherChange = (e) => {
    const id = e.target.value;
    setSelectedButcherId(id);
    const selected = butchers.find(b => b.id.toString() === id.toString());
    setAdvanceAmount(selected ? (selected.advance || 0) : 0);
  };

  const addRowToTable = () => {
    if (!rowInput.category || !rowInput.sub_category || !rowInput.no_of_animal || !rowInput.rate) {
      alert("Please fill all fields!");
      return;
    }
    const selectedCat = animalTypes.find(t => t.id.toString() === rowInput.category.toString());
    const selectedSub = subCategories.find(s => s.id.toString() === rowInput.sub_category.toString());

    const newItem = {
      ...rowInput,
      category_name: selectedCat ? selectedCat.cat_name : "N/A",
      sub_category_name: selectedSub ? (selectedSub.sub_cat || selectedSub.name) : "N/A",
      id: Date.now(),
      total: parseFloat(rowInput.no_of_animal) * parseFloat(rowInput.rate)
    };
    setPaymentList([...paymentList, newItem]);
    setRowInput({ ...rowInput, no_of_animal: "", rate: "", sub_category: "" });
  };

  const grandTotal = paymentList.reduce((sum, item) => sum + item.total, 0);
  const netPayable = grandTotal + parseFloat(advanceAmount || 0) - parseFloat(penalty || 0);

  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/butcher/addPayment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          butcher_id: selectedButcherId,
          advance: advanceAmount,
          total_amount: grandTotal,
          penalty: penalty,
          payment_mode: paymentMethod,
          // Conditional Data
          cheque_no: paymentMethod === 'cheque' ? chequeNo : null,
          bank_name: paymentMethod === 'cheque' ? bankName : null,
          cheque_date: paymentMethod === 'cheque' ? chequeDate : null,
          transaction_id: paymentMethod === 'bank' ? transactionId : null,
          transfer_date: paymentMethod === 'bank' ? transferDate : null,
          net_payable: netPayable,
          items: paymentList
        })
      });

      const result = await response.json();
      if (result.success) {
        alert("Payment Saved Successfully!");
        navigate('/butcher/payment');
      } else {
        alert(result.message || "Error saving payment");
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <div className="p-4 md:p-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
          <div>
            <h1 className="text-2xl font-black text-indigo-900 uppercase tracking-tight">
              Butcher <span className="text-indigo-700">Payment Panel</span>
            </h1>
          </div>
          <button onClick={() => navigate(-1)} className="flex items-center justify-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-slate-600 font-bold text-sm hover:bg-slate-50 shadow-sm transition-all">
            <FiArrowLeft /> BACK
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-6">
            {/* Butcher Selection Section mein teesra column add karen */}
            <div className="bg-white p-6 rounded-[2rem] shadow-sm border border-slate-100">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> {/* md:grid-cols-3 kar diya */}

                {/* Select Butcher */}
                <div className="">
                  <label className="block text-[11px] font-black text-slate-500 uppercase tracking-widest mb-2 ml-1">Select Butcher</label>
                  <select className="w-full px-4 py-3.5 rounded-2xl bg-slate-50 border-2 border-slate-50 focus:border-blue-500 outline-none font-bold text-slate-700" value={selectedButcherId} onChange={handleButcherChange}>
                    <option value="">-- Choose Butcher --</option>
                    {butchers.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
                  </select>
                </div>

                {/* Advance Amount */}
                <div>
                  <label className="block text-[11px] font-black text-slate-500 uppercase tracking-widest mb-2 ml-1">Advance Amount</label>
                  <div className="relative">
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-green-500 font-bold text-sm">Rs.</span>
                    <input type="number" className="w-full pl-12 pr-4 py-3.5 rounded-2xl bg-green-100 border-2 border-green-500 text-green-600 font-black outline-none" value={advanceAmount} readOnly />
                  </div>
                </div>

              </div>
            </div>

            {/* Row Inputs */}
            <div className="bg-white p-6 rounded-[2rem] shadow-sm border border-slate-100">
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4 align-items-end">
                <div className="col-span-1">
                  <label className="text-[10px] font-bold text-slate-500 uppercase ml-1">Day</label>
                  <select className="w-full p-3 rounded-xl bg-slate-50 border border-slate-100 font-bold text-sm" value={rowInput.qurbani_day} onChange={(e) => setRowInput({ ...rowInput, qurbani_day: e.target.value })}>
                    <option value="1">Day 1</option><option value="2">Day 2</option><option value="3">Day 3</option>
                  </select>
                </div>
                <div className="col-span-1">
                  <label className="text-[10px] font-bold text-slate-500 uppercase ml-1">Category</label>
                  <select className="w-full p-3 rounded-xl bg-slate-50 border border-slate-100 font-bold text-sm" value={rowInput.category} onChange={handleCategoryChange}>
                    <option value="">Select</option>
                    {animalTypes.map(type => <option key={type.id} value={type.id}>{type.cat_name}</option>)}
                  </select>
                </div>
                <div className="col-span-2 md:col-span-1">
                  <label className="text-[10px] font-bold text-slate-500 uppercase ml-1">Sub-Category</label>
                  <select className="w-full p-3 rounded-xl bg-slate-50 border border-slate-100 font-bold text-sm" value={rowInput.sub_category} onChange={(e) => setRowInput({ ...rowInput, sub_category: e.target.value })} disabled={!rowInput.category}>
                    <option value="">Select</option>
                    {subCategories.map(item => <option key={item.id} value={item.id}>{item.sub_cat || item.name}</option>)}
                  </select>
                </div>
                <div className="col-span-1">
                  <label className="text-[10px] font-bold text-slate-500 uppercase ml-1">Qty</label>
                  <input type="number" className="w-full p-3 rounded-xl bg-slate-50 border border-slate-100 font-bold text-sm" value={rowInput.no_of_animal} onChange={(e) => setRowInput({ ...rowInput, no_of_animal: e.target.value })} />
                </div>
                <div className="col-span-1">
                  <label className="text-[10px] font-bold text-slate-500 uppercase ml-1">Rate</label>
                  <input type="number" className="w-full p-3 rounded-xl bg-slate-50 border border-slate-100 font-bold text-sm" value={rowInput.rate} onChange={(e) => setRowInput({ ...rowInput, rate: e.target.value })} />
                </div>
              </div>
              <button type="button" className="w-full mt-6 py-4 bg-indigo-900 text-white rounded-2xl font-black text-xs uppercase hover:bg-indigo-700 flex items-center justify-center gap-2 shadow-lg" onClick={addRowToTable}>
                <FiPlus size={18} /> Add to List
              </button>
            </div>

            {/* List Table */}
            <div className="bg-white rounded-[2rem] shadow-sm border border-slate-100 overflow-hidden">
              <table className="w-full text-left">
                <thead className="bg-slate-50 border-b">
                  <tr className="text-[11px] font-black text-slate-400 uppercase tracking-widest">
                    <th className="p-5">Detail</th>
                    <th className="p-5 text-center">Qty</th>
                    <th className="p-5 text-center">Total</th>
                    <th className="p-5 text-center">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-50">
                  {paymentList.map((item) => (
                    <tr key={item.id} className="hover:bg-slate-50">
                      <td className="p-5">
                        <p className="font-bold text-slate-700 text-sm">{item.sub_category_name}</p>
                        <span className="text-[9px] font-black px-2 py-0.5 bg-blue-50 text-blue-600 rounded uppercase">Day {item.qurbani_day}</span>
                      </td>
                      <td className="p-5 text-center font-black">{item.no_of_animal}</td>
                      <td className="p-5 text-center font-black text-blue-600">Rs. {item.total.toLocaleString()}</td>
                      <td className="p-5 text-center">
                        <button className="text-red-400" onClick={() => setPaymentList(paymentList.filter(p => p.id !== item.id))}><FiTrash2 size={18} /></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* RIGHT COLUMN: Summary & Payment Settings */}
          <div className="lg:col-span-1">
            <div className="bg-white p-8 rounded-[2.5rem] shadow-sm border border-slate-100 sticky top-24">
              <h3 className="text-lg font-black text-slate-800 uppercase mb-8 border-b pb-4">Payment Summary</h3>

              <div className="space-y-6">
                {/* Payment Mode Selection */}
                <div>
                  <label className="text-[10px] font-black text-slate-400 uppercase mb-2 block ml-1">Payment Mode</label>
                  <div className="relative">
                    <FiCreditCard className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
                    <select className="w-full pl-11 pr-4 py-3.5 rounded-2xl bg-slate-50 border-2 border-slate-50 font-bold text-slate-700 appearance-none focus:border-indigo-500" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                      <option value="cash">Cash Payment</option>
                      <option value="cheque">Cheque</option>
                      <option value="bank">Bank Transfer / Online</option>
                    </select>
                  </div>
                </div>

                {/* Conditional Cheque Fields */}
                {paymentMethod === 'cheque' && (
                  <div className="space-y-3 p-4 bg-blue-50 rounded-2xl animate-in fade-in duration-300">
                    <p className="text-[10px] font-black text-blue-500 uppercase mb-1">Cheque Info</p>
                    <div className="relative"><FiHash className="absolute left-3 top-3 text-blue-300" /><input type="text" placeholder="Cheque #" className="w-full pl-9 p-2 rounded-xl text-sm font-bold border-none" value={chequeNo} onChange={(e) => setChequeNo(e.target.value)} /></div>
                    <input type="text" placeholder="Bank Name" className="w-full p-2 rounded-xl text-sm font-bold border-none" value={bankName} onChange={(e) => setBankName(e.target.value)} />
                    <div className="relative"><FiCalendar className="absolute left-3 top-3 text-blue-300" /><input type="date" className="w-full pl-9 p-2 rounded-xl text-sm font-bold border-none text-slate-400" value={chequeDate} onChange={(e) => setChequeDate(e.target.value)} /></div>
                  </div>
                )}

                {/* Conditional Bank/Online Fields */}
                {paymentMethod === 'bank' && (
                  <div className="space-y-3 p-4 bg-purple-50 rounded-2xl animate-in fade-in duration-300">
                    <p className="text-[10px] font-black text-purple-500 uppercase mb-1">Transfer Info</p>
                    <div className="relative"><FiHash className="absolute left-3 top-3 text-purple-300" /><input type="text" placeholder="Transaction ID (T-ID)" className="w-full pl-9 p-2 rounded-xl text-sm font-bold border-none" value={transactionId} onChange={(e) => setTransactionId(e.target.value)} /></div>
                    <div className="relative"><FiCalendar className="absolute left-3 top-3 text-purple-300" /><input type="date" className="w-full pl-9 p-2 rounded-xl text-sm font-bold border-none text-slate-400" value={transferDate} onChange={(e) => setTransferDate(e.target.value)} /></div>
                  </div>
                )}

                {/* Penalty Input */}
                <div>
                  <label className="text-[10px] font-black text-slate-400 uppercase mb-2 block ml-1">Penalty / Deduction</label>
                  <div className="relative">
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-red-600 font-bold text-sm">Rs.</span>
                    <input type="number" className="w-full pl-11 pr-4 py-3.5 rounded-2xl bg-red-100 border-2 border-red-500 text-red-700 font-black outline-none" value={penalty} onChange={(e) => setPenalty(e.target.value)} />
                  </div>
                </div>

                {/* Final Calculations */}
                <div className="space-y-3 pt-4 border-t text-xl">
                  <div className="flex justify-between text-sm font-bold text-slate-500"><span>Grand Total</span><span>Rs. {grandTotal.toLocaleString()}</span></div>
                  <div className="flex justify-between text-sm font-bold text-green-600"><span>Advance</span><span>- Rs. {parseFloat(advanceAmount || 0).toLocaleString()}</span></div>
                  <div className="flex justify-between text-sm font-bold text-red-600"><span>Penalty</span><span>- Rs. {parseFloat(penalty || 0).toLocaleString()}</span></div>
                </div>

                <div className="py-6 bg-indigo-800 rounded-3xl mt-4 text-center">
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Net Payable Amount</p>
                  <h2 className="text-3xl font-black text-white">Rs. {netPayable.toLocaleString()}</h2>
                </div>

                <button className="w-full py-5 bg-indigo-800 text-white rounded-2xl font-black text-sm uppercase hover:bg-blue-700 transition-all shadow-xl disabled:opacity-50" onClick={handleSubmit} disabled={paymentList.length === 0 || !selectedButcherId}>
                  Confirm & Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}